import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import Spinner from '../common/spinner';
import { createSurveyFromLocation } from '../modules/locationdata';
import { getSurveyEnrichment } from '../modules/surveydata';
import SurveyEditView from './surveyeditview';

export default function SurveyCreateContainer(props) {
    const id = props.match.params.locationId;
    const dispatch = useDispatch();
    const [survey, setSurvey] = useState(null);
    const [surveyEnrichment, setSurveyEnrichment] = useState(null);

    useEffect(() => {
        async function createSurveyData() {
            var resp = await createSurveyFromLocation(id)(dispatch);
            setSurvey(resp);
        }
        async function getSurveyEnrichmentData() {
            var resp = await getSurveyEnrichment(id)(dispatch);
            setSurveyEnrichment(resp);
        }

        createSurveyData();
        getSurveyEnrichmentData();
    }, [id, dispatch]);

    if (!survey || !surveyEnrichment) {
        return <Spinner />;
    }
    return <SurveyEditView survey={survey} surveyEnrichment={surveyEnrichment} history={props.history} />;
}
